import { Directive, ElementRef, HostListener, AfterViewInit, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[autoresize]',
  standalone: true
})
export class AutoResizeDirective implements OnInit {
  constructor(private element: ElementRef) { }

  ngOnInit(): void {
    setTimeout(() => this.adjust(), 0); // Delay to ensure content is rendered
  }
  @HostListener('input', ['$event.target'])
  onChange(textArea: HTMLTextAreaElement): void {
    this.adjust();
  }

  adjust(): void {

    const textArea = this.element.nativeElement as HTMLTextAreaElement;
    textArea.style.minHeight = '20px';
    if (textArea.scrollHeight!= 0) {
      textArea.style.height = '1px';
      textArea.style.height = textArea.scrollHeight - 4 + 'px';

    }
  }
}